import { render, staticRenderFns } from "./ReportMaterialsTableDispatcher.vue?vue&type=template&id=dd92bc9a&scoped=true&"
import script from "./ReportMaterialsTableDispatcher.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsTableDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./ReportMaterialsTableDispatcher.vue?vue&type=style&index=0&id=dd92bc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd92bc9a",
  null
  
)

export default component.exports
import {QItem,QTable,QTh,QTr,QTd,QBtn,QTooltip,QCheckbox,QItemSection,QSelect,QInput,QIcon,QBadge,QDialog,QCard,QCardSection,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QItem,QTable,QTh,QTr,QTd,QBtn,QTooltip,QCheckbox,QItemSection,QSelect,QInput,QIcon,QBadge,QDialog,QCard,QCardSection,QSeparator,QCardActions}, component.options.components || {})
